module.exports = __webpack_public_path__ + "static/media/signup-logo.ba77ef01.png";